export default __webpack_public_path__ + "static/media/DSC02128.d45315a2.jpg";